function validateInput(state, key) {
  console.log('state', state);

  const errors = {};
  let isValid = true;
  const value = state[key]; 
  switch (key) {
    case "kycRemark":
      if (!value || value.trim() === "") {
        console.log("insideif")
        errors.kycRemarkError = "Please fill in the KYC remarks before approving";
        isValid = false;
      } 
      break;
    case "kycRejectRemark":
      if ((!value || value.trim() === "") && state.rejectionReason === "Other") {
        errors.kycRejectRemarkError = "Please fill all details for rejection";
        isValid = false;
      }
      break;
    default:
      console.log(`Validation not explicitly defined for key: ${key}`);
      break;
  }

  return {
    errors,
    isValid,
  };
}

export default validateInput;